export default "__VITE_ASSET__a93fc284__"